import React, { useState, useContext, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  TextArea,
  Toast,
  DatePicker,
  NavBar,
  Selector,
} from "antd-mobile";
import "./index.css";
import { useNavigate, useLocation } from "react-router-dom";
import {
  parseQueryString,
  opt_products,
  opt_type,
  opt_level,
  opt_module,
  opt_isKeyPoint,
  opt_probability,
} from "../interface";
import { Upload, Modal, Select } from "antd";
import axios from "axios";
import moment from "moment";
import { domain } from "../interface";
import COS from "cos-js-sdk-v5";
import { PlusOutlined } from "@ant-design/icons";
import * as _ from "lodash";

let fileListObj = [];
const Distribute = () => {
  //定义一个cos 对象
  const cos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
      // 异步获取临时密钥
      var url = domain + "/form/getPolicy"; // url替换成您自己的后端服务
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      console.log("get COS  policy ...");
      xhr.onload = function (e) {
        try {
          var data = JSON.parse(e.target.responseText).data;
          var credentials = data.credentials;
        } catch (e) {}
        if (!data || !credentials) {
          return console.error(
            "credentials invalid:\n" + JSON.stringify(data, null, 2)
          );
        }
        callback({
          TmpSecretId: credentials.tmpSecretId,
          TmpSecretKey: credentials.tmpSecretKey,
          SecurityToken: credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
          ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
        });
      };
      xhr.send();
    },
  });

  let navigate = useNavigate();
  let location = useLocation();

  const [pathUrl, setPathUrl] = useState(
    parseQueryString(window.location.href)
  );
  const [form] = Form.useForm();
  const [customerCode, setCustomerCode] = useState("");
  const [customerLevel, setCustomerLevel] = useState("");
  const [productId, setproductId] = useState("option-1676102769407");
  const [customerName, setcustomerName] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [planTime, setPlanTime] = useState(moment().format("YYYY-MM-DD"));
  const [visible, setVisible] = useState(false);

  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreViewImage] = useState();
  const [previewTitle, setPreviewTitle] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const cosBucketName = "station-dev-1306515598";
  const cosRegion = "ap-shanghai";
  const cosKeySuffix = "dingobject/test/";
  const cosStorageClass = "STANDARD";

  /** 上传图片的按钮 */
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const onProductChange = (e) => {
    console.log(e, "e值为");
    setproductId(e.target.value);
    form.setFieldsValue({
      module: "option-1676103442876",
    });
  };

  /** 文件转化成64位 */
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  /** 图片预览 */
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreViewImage(file.url || file.preview);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
    setPreviewVisible(true);
  };

  /** 改变图片的回调 */
  const handleChange = ({ fileList }) => {
    const newFileList = _.uniqBy(fileList, (item) => item.uid);
    setFileList(newFileList);
  };

  /** 上传之前的会掉 */
  const beforeUpload = async (file, fileList) => {
    return true;
  };

  const onFinish = (values) => {
    let fliestr =
      "https://station-dev-1306515598.cos.ap-shanghai.myqcloud.com/" +
      cosKeySuffix;
    let filUrlList = [];
    let attrl = "";
    for (const item of fileList) {
      let fullUrl = fliestr + item.originFileObj.filename;
      filUrlList.push(fullUrl);
      if (attrl == "") {
        attrl = fullUrl;
      } else {
        attrl = attrl + "||" + fullUrl;
      }
    }

    // alert(attrl);
    // return;

    let params = {
      module: "option-1676103442875",
      ...values,
      attachmentUrl: attrl,
      fileList: filUrlList,
      planTime: planTime,
    };
    let userId = localStorage.getItem("userId");
    let userName = localStorage.getItem("userName");
    if (userName == null || userName == "") {
      userName = "邢汝华";
    }

    if (userId == null || userId == "") {
      userId = "ruhua";
    }
    console.log(params);
    setIsDisabled(true);
    axios
      .post(domain + "/form/approve", {
        ...params,
        userId: userId,
        userName: userName,
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200 && res.data) {
          if (res.data.code == 200) {
            Toast.show({
              content: "保存成功",
            });
            //清空数字
            fileListObj.splice(0, fileListObj.length);
            navigate("/home");
          } else {
            Toast.show({
              content: res.data.message,
            });
          }
        } else {
          Toast.show({
            content: "操作失败",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // if (Object.keys(pathUrl).length > 0) {
    // localStorage.getItem("attachmentUrl") != "undefined" && localStorage.getItem("attachmentUrl") != "null"

    const { state } = location;
    if (state != null && state.hasStorage === "1") {
      //如果是查看详情跳转用跳转的id调用详情接口
      //否则是选择客户跳转
      const values = form.getFieldsValue();
      let objForm = {};
      for (let k in values) {
        objForm[k] =
          localStorage.getItem(k) != "undefined" &&
          localStorage.getItem(k) != "null"
            ? localStorage.getItem(k)
            : "";
      }
      setCustomerCode(
        localStorage.getItem("customerCode") != "undefined" &&
          localStorage.getItem("customerCode") != "null"
          ? localStorage.getItem("customerCode")
          : ""
      );

      setCustomerLevel(
        localStorage.getItem("customerLevel") != "undefined" &&
          localStorage.getItem("customerLevel") != "null"
          ? localStorage.getItem("customerLevel")
          : ""
      );

      setcustomerName(localStorage.getItem("customerName") || "");
      setAttachmentUrl(
        localStorage.getItem("attachmentUrl") != "undefined" &&
          localStorage.getItem("attachmentUrl") != "null"
          ? localStorage.getItem("attachmentUrl")
          : ""
      );
      setPlanTime(
        localStorage.getItem("planTime") != "undefined" &&
          localStorage.getItem("planTime") != "null"
          ? localStorage.getItem("planTime")
          : ""
      );

      let lfileList = localStorage.getItem("fileList");
      if (
        lfileList != null &&
        fileList != "undefined" &&
        lfileList != "null" &&
        lfileList != "" &&
        lfileList != "[]"
      ) {
        setFileList(JSON.parse(localStorage.getItem("fileList")));
        fileListObj = JSON.parse(localStorage.getItem("fileList"));
      } else {
        setFileList([]);
        fileListObj = [];
      }
      form.setFieldsValue({ ...objForm });
    } else {
      //新增表单
      console.log("insert form");
      form.setFieldsValue({ module: "option-1676103442876" });
    }
  }, [pathUrl]);

  //跳转到选择客户页面
  const goCustomer = () => {
    const values = form.getFieldsValue();
    for (let k in values) {
      localStorage.setItem(k, values[k]);
    }
    localStorage.setItem("customerCode", customerCode);
    localStorage.setItem("customerLevel", customerLevel);
    localStorage.setItem("attachmentUrl", attachmentUrl);
    localStorage.setItem("planTime", planTime);
    localStorage.setItem("fileList", JSON.stringify(fileList));
    localStorage.setItem("navigate", "distribute");

    // localStorage.setItem("fileListObj",JSON.stringify(fileListObj));

    navigate("/customer");
  };

  // const getDetails = (id) => {
  //     axios
  //         .post(domain + "/form/find/form", { id })
  //         .then((res) => {
  //             console.log(res);
  //             if (res.status == 200 && res.data) {
  //                 form.setFieldsValue(res.data)
  //                 if (res.data.code == 200 && res.data.data) {
  //                     form.setFieldsValue(res.data.data);
  //                     setCustomerCode(res.data.data.customerCode);
  //                     setPlanTime(res.data.data.planTime);
  //                 } else {
  //                     Toast.show({
  //                         content: res.data.message,
  //                     })
  //                 }
  //             } else {
  //                 form.setFieldsValue({})
  //             }
  //         })
  //         .catch((error) => {
  //             console.log(error)
  //         });
  // }

  //上传文件
  const uploadProps = {
    name: "file",
    maxCount: 5,
    headers: {
      authorization: "authorization-text",
    },

    // customRequest(info){
    customRequest: async (info) => {
      // const newFileList = _.cloneDeep(fileList);
      let imgItem = info.file;

      let tmpFileName = info.file.name;
      let newFileName =
        moment.now() + tmpFileName.substring(tmpFileName.lastIndexOf("."));

      imgItem.filename = newFileName;

      const listItem = {
        ...imgItem,
        status: "done",
        url: await getBase64(imgItem),
        originFileObj: imgItem,
      };

      //   fileListObj.push(listItem);
      //   setFileList([...fileListObj]);
      cos.putObject(
        {
          Bucket: cosBucketName /* 填入您自己的存储桶，必须字段 */,
          Region: cosRegion /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key:
            cosKeySuffix +
            imgItem.filename /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
          StorageClass: cosStorageClass,
          Body: info.file, // 上传文件对象
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function (err, data) {
          if (err != null) {
            alert("上传文件失败！", err);
            return;
          } else {
            fileListObj.push(listItem);
            setFileList([...fileListObj]);
          }
        }
      );
    },
    onChange(info) {
      console.log("info.file.status:", info.file.status);
      if (info.file.status == "removed") {
        // console.log(info);
        // console.log(fileListObj);
        fileListObj.splice(
          fileListObj.findIndex((item) => item.uidid === info.uid),
          1
        );
        setFileList([...fileListObj]);
      }
      if (info.file.status === "done") {
        console.log(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        console.log(`${info.file.name} file upload failed.`);
      }
    },
  };

  /** 粘贴快捷键的回调 */
  const onPaste = async (e) => {
    /** 获取剪切板的数据clipboardData */
    var clipboardData = e.clipboardData,
      i = 0,
      items,
      item,
      types;

    /** 为空判断 */
    if (clipboardData) {
      items = clipboardData.items;

      if (!items) {
        return;
      }

      item = items[0];
      types = clipboardData.types || [];
      /** 遍历剪切板的数据 */
      for (; i < types.length; i++) {
        if (types[i] === "Files") {
          item = items[i];
          break;
        }
      }

      /** 判断文件是否为图片 */
      if (item && item.kind === "file" && item.type.match(/^image\//i)) {
        const imgItem = item.getAsFile();
        imgItem.filename = moment.now() + ".png";
        // const newFileList = _.cloneDeep(fileListObj);
        // const newFileList = _.cloneDeep(fileList);

        const listItem = {
          ...imgItem,
          status: "done",
          url: await getBase64(imgItem),
          originFileObj: imgItem,
        };

        // fileListObj.push(listItem);
        // newFileList.push(listItem);

        // console.log(imgItem, fileListObj, getBase64(imgItem))

        // setFileList(newFileList)
        cos.putObject(
          {
            Bucket: cosBucketName,
            Region: cosRegion,
            Key: cosKeySuffix + imgItem.filename,
            StorageClass: cosStorageClass,
            Body: imgItem, // 上传文件对象
            onProgress: function (progressData) {
              console.log(JSON.stringify(progressData));
            },
          },
          function (err, data) {
            // console.log("data:",data);
            if (err != null) {
              console.error("上传文件失败！");
              return;
            } else {
              fileListObj.push(listItem);
              console.log("fileListObj=", fileListObj.length);

              setFileList([...fileListObj]);
              // setFileList([listItem,...fileList])
            }
          }
        );
      }
    }
  };

  //贴图
  useEffect(() => {
    document.addEventListener("paste", onPaste);
    return () => {
      document.removeEventListener("paste", onPaste);
    };
  }, []);

  const now = new Date();

  const back = () => {
    window.history.back(-1);
  };

  useEffect(() => {
    console.log(form.getFieldValue("product"), "prodcut值为");
  }, []);

  return (
    <div className="page distributePage">
      {/* <NavBar onBack={back}>表单编辑</NavBar> */}
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={{
          product: "option-1676102769407",
          level: "option-1676785110983",
          type: "option-1676783759525",
          module: "option-1676103442876",
          probability: "option-1682237882315",
          isKeyPoint: "option-1682237932456",
        }}
        footer={
          !pathUrl.id && (
            <Button
              disabled={isDisabled}
              block
              type="submit"
              color="primary"
              size="large"
            >
              提交
            </Button>
          )
        }
      >
        <Form.Item
          name="title"
          label="问题标题"
          rules={[{ required: true, message: "标题不能为空" },{ max:50, message: "标题长度不能超过50！" }]}
        >
          <Input
            placeholder="请输入标题"
            disabled={pathUrl.id}
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item name="content" label="问题描述">
          <TextArea
            placeholder="请输入"
            disabled={pathUrl.id}
            rows={5}
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          className="customeNameBox"
          name="customerName"
          label="客户名称"
          rules={[{ required: true, message: "客户名称不能为空" }]}
        >
          <Input
            placeholder="非客户case，选择：上海美市科技"
            value={customerName}
            disabled
            autoComplete="off"
          />
          {!pathUrl.id && (
            <Button
              onClick={() => {
                goCustomer();
              }}
              className="editCustomer"
              block
              color="primary"
              size="small"
            >
              选择客户
            </Button>
          )}
        </Form.Item>
        <Form.Item
          className="btnselect"
          name="customerCode"
          label="客户代码"
          rules={[{ required: true, message: "客户代码不能为空" }]}
        >
          <Input
            placeholder=""
            value={customerCode}
            disabled
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          className="btnselect"
          name="customerLevel"
          label="客户级别"
          rules={[{ required: true, message: "客户级别不能为空" }]}
        >
          <Input
            placeholder=""
            value={customerLevel}
            disabled
            autoComplete="off"
          />
        </Form.Item>


        <Form.Item name="customerRelator" 
        label="问题反馈客户姓名"
        rules={[{ required: true, message: "问题反馈客户姓名" },{ max:50, message: "问题反馈客户姓名不能超过50！" }]}
        >
          <Input
            placeholder="请输入"
            disabled={pathUrl.id}
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item
          name="product"
          label="所属产品"
          rules={[{ required: true, message: "所属产品不能为空" }]}
        >
          <select
            className="editSelect"
            disabled={pathUrl.id}
            onChange={onProductChange}
          >
            {opt_products.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>

        <Form.Item
          name="probability"
          label="商机赢率"
          rules={[{ required: true, message: "所属商机赢率不能为空" }]}
        >
          <select className="editSelect" disabled={pathUrl.id}>
            {opt_probability.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>

        <Form.Item
          name="isKeyPoint"
          label="是否回款池客户"
          rules={[{ required: true, message: "是否回款池客户" }]}
        >
          <select className="editSelect" disabled={pathUrl.id}>
            {opt_isKeyPoint.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>

        <Form.Item
          name="type"
          label="问题类型"
          rules={[{ required: true, message: "问题类型不能为空" }]}
        >
          <select className="editSelect" disabled={pathUrl.id}>
            {opt_type.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>

        {productId === "option-1676102769407" ||
        productId === "option-1676102769408"  

         ? (
          <Form.Item
            name="module"
            label="系统模块"
            initialValue={undefined}
            rules={[{ required: true, message: "系统模块不能为空" }]}
          >
            <select className="editSelect" disabled={pathUrl.id}>
              {opt_module.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </Form.Item>
        ) : (
          ""
        )}

        <Form.Item
          name="level"
          label="优先级"
          initialValue={"2"}
          rules={[{ required: true, message: "优先级不能为空" }]}
        >
          <select className="editSelect" disabled={pathUrl.id}>
            {opt_level.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </Form.Item>
        {!pathUrl.id && (
          <Form.Item className="btnselect" name="attachmentUrl" label="附件">
            <Input
              placeholder=""
              disabled
              autoComplete="off"
              style={{ width: 2 }}
            />
            {!pathUrl.id && (
              <Upload
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                multiple={true}
                beforeUpload={beforeUpload}
                onChange={handleChange}
                {...uploadProps}
              >
                <Button
                  className="editCustomer"
                  block
                  color="primary"
                  size="large"
                >
                  上传附件
                </Button>
              </Upload>
            )}
            <Modal
              visible={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={() => {
                setPreviewVisible(false);
              }}
            >
              <img alt="example" style={{ width: "10%" }} src={previewImage} />
            </Modal>
          </Form.Item>
        )}
        {
          <Form.Item name="attachmentUrl" label="附件">
            <Input disabled autoComplete="off" />
          </Form.Item>
        }
      </Form>
    </div>
  );
};
export default Distribute;
